import { render } from "./VideoListV2.vue?vue&type=template&id=1da578ae&scoped=true"
import script from "./VideoListV2.vue?vue&type=script&lang=js"
export * from "./VideoListV2.vue?vue&type=script&lang=js"

import "./VideoListV2.vue?vue&type=style&index=0&id=1da578ae&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da578ae"]])

export default __exports__